"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RevocationListPayload = exports.RevocationEntry = exports.AuditActionInput = exports.AuditEventSummary = void 0;
const zod_1 = require("zod");
const enums_js_1 = require("./enums.js");
exports.AuditEventSummary = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    resource_version_id: zod_1.z.string().uuid().nullable(),
    composer_version_id: zod_1.z.string().uuid().nullable(),
    actor_id: zod_1.z.string().uuid(),
    actor_username: zod_1.z.string().optional(),
    action: zod_1.z.enum(enums_js_1.AuditActions),
    rationale: zod_1.z.string().nullable(),
    created_at: zod_1.z.string().datetime(),
});
exports.AuditActionInput = zod_1.z.object({
    action: zod_1.z.enum(enums_js_1.AuditActions),
    rationale: zod_1.z.string().min(1).max(2000).optional(),
    mark_permanent: zod_1.z.boolean().optional(),
    expires_in_seconds: zod_1.z
        .number()
        .int()
        .positive()
        .max(63072000) // 24 months cap per spec §1
        .optional(),
});
exports.RevocationEntry = zod_1.z.object({
    resource_version_id: zod_1.z.string().uuid().nullable(),
    composer_version_id: zod_1.z.string().uuid().nullable(),
    revoked_at: zod_1.z.string().datetime(),
    list_version: zod_1.z.number().int().positive(),
});
exports.RevocationListPayload = zod_1.z.object({
    list_version: zod_1.z.number().int().positive(),
    entries: zod_1.z.array(exports.RevocationEntry),
    signed_envelope: zod_1.z.object({
        canonical_json: zod_1.z.string(),
        signature_b64: zod_1.z.string(),
        signing_key_id: zod_1.z.string().uuid(),
    }),
});
//# sourceMappingURL=audit.schema.js.map